export const MATCHER_PHONE_VERIFICATION_CODE_REGEX = /^\d{6}$/;
